import { render, staticRenderFns } from "./DuDocumentLayout.vue?vue&type=template&id=e81d5f74&"
import script from "./DuDocumentLayout.vue?vue&type=script&lang=js&"
export * from "./DuDocumentLayout.vue?vue&type=script&lang=js&"
import style0 from "./DuDocumentLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports